import { useState } from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import "../Navbar.scss";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

export const ListItemSimple = ({ item }) => (
  <ListItemButton component="a" href={item?.url}>
    <ListItemText style={{ textAlign: "left" }} primary={item?.title} />
  </ListItemButton>
);

export const ListItemWithSubList = ({ item }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemText style={{ textAlign: "left" }} primary={item?.title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List style={{ marginLeft: 20 }} component="div" disablePadding>
          {item?.itemList?.filter(Boolean).map((subitem, _index) => (
            <ListItemButton key={`sublist-mobile-${subitem?.id ?? _index}`} component="a" href={subitem?.url}>
              <ListItemText style={{ textAlign: "left" }} primary={subitem?.title} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};
